
























































































import { Component, Vue } from 'vue-property-decorator';

import Page from '@/componentsV2/molecules/Page/Page.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import LaunchRewardsProgramEmptyState from '@/componentsV2/organisms/LaunchRewardsProgramEmptyState/LaunchRewardsProgramEmptyState.vue';

import DateUtils from '@/utils/DateUtils';

import { TProgramStatus } from '@/models/program-status';

import ProgramStatusItem from './ProgramStatusItem.vue';
import { needLaunchRewardsProgram } from '@/utils/start-guide';
import { EBusinessRewardsStatus, IBusinessType } from '@/models/business';
import { upperCaseFirstLetter } from '@/utils/string';
import { widgetIsActive } from '@/router/validators/utils';
import BusinessService from '@/api/BusinessService';
import eventBus from '@/utils/eventBus';
import { isOnlineProvider } from '@/utils/provider';
import InfoIcon from '@/components/icons/InfoV2.vue';
import Checkbox from '@/components/Checkbox/Checkbox.vue';
import flagKeys from '@/constants/flagKeys';
import { ModalOptionsV2 } from '@/components/Modal/ModalOptions';

@Component({
  components: {
    Page,
    Typography,
    ProgramStatusItem,
    LaunchRewardsProgramEmptyState,
    InfoIcon,
    Checkbox
  }
})
export default class ProgramStatus extends Vue {
  sinceDate = '';
  updatedAt = '';

  programStatus: TProgramStatus[] = [];
  operationType: string = '';
  service: BusinessService = new BusinessService();

  rewardStatus: any = {};

  collapsed = false;

  get tPrefix() {
    return 'programStatus';
  }

  get isNeedProviderConnected() {
    return needLaunchRewardsProgram(true);
  }

  get pageTitle() {
    return this.$t(`${this.tPrefix}.title`);
  }

  get isProviderDisconnected() {
    return this.businessInfo.type === IBusinessType.ONLINE && !widgetIsActive();
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessState'];
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get deactivationFlagEnabled() {
    return this.flags.includes(flagKeys.loyaltyProgramDeactivation);
  }

  get rewardsActive() {
    return this.rewardStatus === EBusinessRewardsStatus.ACTIVE;
  }

  get rewardsLastUpdated() {
    if (!this.updatedAt) return '';
    return DateUtils.formattedDate({
      date: this.updatedAt,
      applyTimezone: true
    });
  }

  get toggleLabel() {
    return {
      activeLabel: 'Active',
      inactiveLabel: 'Inactive'
    };
  }

  get tooltipMessage() {
    return `Loyalty Rewards Program ${
      this.rewardsActive ? 'activated' : 'deactivated'
    } on ${this.rewardsLastUpdated}.`;
  }

  async changedActivation() {
    eventBus.$emit(
      'openSubModal',
      new ModalOptionsV2({
        componentToRender: `toggleRewardsModal`,
        hideCancelButton: false,
        icon: '',
        mobilePositionBottom: true,
        mobileFullScreen: false
      }),
      {
        mobilePositionBottom: true,
        activeRewards: !this.rewardsActive,
        type: this.operationType,
        onSuccess: async () => {
          await this.loadProgramStatus();
        },
        origin: 'switch'
      }
    );
  }

  addRowsToList(rows: any) {
    const response = [];
    const cardsLabel: any = {
      amex: 'American Express',
      mastercard: 'Mastercard',
      visa: 'Visa'
    };

    for (let i = 0; i < rows.length; i++) {
      const element = rows[i];

      if (element.locations.length) {
        element.locations.map((location: any) => {
          response.push({
            ...element,
            ...location,
            label: location.locationName,
            subTitle: location.locationAddress,
            cards: Object.keys(cardsLabel).map((card: any) => ({
              ...location[card],
              type: card,
              label: cardsLabel[card]
            }))
          });
        });
      } else {
        if (isOnlineProvider(element.provider)) {
          response.push({
            ...element,
            label: this.$t(`${this.tPrefix}.labelCard.online`),
            subTitle: this.businessInfo.website
          });
        } else {
          response.push({
            ...element,
            label: this.$t(`${this.tPrefix}.labelCard.physical`),
            subTitle: this.$t(`${this.tPrefix}.subTitleInStore`, {
              provider: upperCaseFirstLetter(element.provider)
            })
          });
        }
      }
    }

    return response;
  }

  clickCollapse() {
    this.collapsed = !this.collapsed;
  }

  async loadProgramStatus() {
    try {
      this.$showLoaderWithLocker();
      const { data } = await this.service.getRewardStatusList();

      this.rewardStatus = data.operationStatus;

      this.updatedAt = data.updatedAt;
      this.operationType =
        data.operationType || this.businessInfo.operationType;

      this.programStatus = this.addRowsToList(data.providers);

      this.$store.dispatch('business/SET_REWARD_STATUS', data);

      if (data.since)
        this.sinceDate = DateUtils.formattedDate({
          date: data.since,
          applyTimezone: true
        });
    } finally {
      this.$hideLoader();
    }
  }

  created() {
    if (this.$store.getters['business/getRewardStatus'])
      this.rewardStatus = this.$store.getters[
        'business/getRewardStatus'
      ].operationStatus;
    this.loadProgramStatus();
    eventBus.$on('rewardProgramSuccess', this.loadProgramStatus);
  }

  beforeDestroy() {
    eventBus.$off('rewardProgramSuccess', this.loadProgramStatus);
  }
}
